import { SortField, SortIndexField } from '__generated__/graphql'

const SORT_REGISTRY: Record<string, SortIndexField> = {
    rosterName: SortIndexField.RosterName,
    rosterCompany: SortIndexField.RosterCompany,
    rosterCreatedAt: SortIndexField.RosterCreatedAt,
    rosterCreatedBy: SortIndexField.RosterCreatedBy,
    rosterStatus: SortIndexField.RosterStatus,
    rosterType: SortIndexField.RosterType,
    rosterCandidateCount: SortIndexField.RosterCandidateCount,
    processStatus: SortIndexField.ProcessStatus,
    processStatusUpdatedAt: SortIndexField.ProcessStatusUpdatedAt,
    sourceStatus: SortIndexField.SourceStatus,
    internalNote: SortIndexField.RosterInternalNote,
}

const FIELD_TO_KEY = Object.fromEntries(
    Object.entries(SORT_REGISTRY).map(([key, field]) => [field, key])
) as Record<SortIndexField, string>

export function encodeSort(sort: SortField[]): string {
    return sort
        .map((s) => {
            const key = FIELD_TO_KEY[s.field]
            return key ? `${key}~${s.order}` : null
        })
        .filter(Boolean)
        .join('.')
}

export function decodeSort(str: string): SortField[] {
    if (!str) return []
    return str
        .split('.')
        .map((part) => {
            const [key, order] = part.split('~')
            const field = SORT_REGISTRY[key]
            if (!field || !order) return null
            return { field, order }
        })
        .filter((s): s is SortField => s !== null)
}
